import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import {
  Container,
  Tick,
  IconContainer,
  ActiveText,
  Separator,
  NumberIcon,
  InactiveText,
  Bullet,
} from './styles'

export const WizardHeader = ({ step }: { step: 2 | 3 | 4 }) => {
  const { i18n } = useI18n()
  const { isTablet, isPhone } = useMediaQueries()

  if (isPhone) {
    return null
  }

  if (isTablet) {
    return (
      <Container>
        <Bullet className="active" />
        <Bullet className={step >= 3 ? 'active' : ''} />
        <Bullet className={step === 4 ? 'active' : ''} />
      </Container>
    )
  }

  return (
    <Container>
      <IconContainer className="blue">
        <Tick />
      </IconContainer>
      <ActiveText>{i18n.t('builder.billing.wizard.create')}</ActiveText>
      <Separator />
      <IconContainer className="blue">
        {step === 2 ? <NumberIcon>2</NumberIcon> : <Tick />}
      </IconContainer>
      <ActiveText>{i18n.t('builder.billing.wizard.choose')}</ActiveText>
      <Separator />
      <IconContainer className={step > 2 ? 'blue' : ''}>
        {step < 4 ? <NumberIcon className={step === 2 ? 'inactive' : ''}>3</NumberIcon> : <Tick />}
      </IconContainer>
      {step >= 3 ? (
        <ActiveText>{i18n.t('builder.billing.wizard.payment')}</ActiveText>
      ) : (
        <InactiveText>{i18n.t('builder.billing.wizard.payment')}</InactiveText>
      )}
      <Separator />
      <IconContainer className={step > 3 ? 'blue' : ''}>
        <NumberIcon className={step === 3 ? 'inactive' : ''}>4</NumberIcon>
      </IconContainer>
      {step === 4 ? (
        <ActiveText>{i18n.t('builder.billing.wizard.download')}</ActiveText>
      ) : (
        <InactiveText>{i18n.t('builder.billing.wizard.download')}</InactiveText>
      )}
    </Container>
  )
}
